import { Directive, HostListener, ElementRef, Injectable, inject } from '@angular/core';

@Directive({
    selector: '[appDate]',
    standalone: false
})
export class DateDirective {

    el = inject(ElementRef);
    service = inject(DataFieldDirectiveService);

    constructor() { }

    @HostListener('input', ['$event']) onInputChange(event: Event) {
        let nativeElement = this.el.nativeElement as HTMLInputElement;
        if (nativeElement.tagName != 'input') {
            nativeElement = nativeElement.querySelector('input') as HTMLInputElement;
        }

        if (nativeElement) {
            const initalValue = nativeElement.value;
            const value = this.service.maskDate(initalValue);
            if (value !== nativeElement.value) {
                nativeElement.value = value;
                event.stopPropagation();
            }
        }

    }

}

@Injectable({
    providedIn: 'root'
})
export class DataFieldDirectiveService {

    maskDate(dateString: string): string {
        let value = dateString;
        if (!value) return '';
        value = value.replace(/\D/g, ''); // Remove non-numeric characters

        if (value.length > 10) {
            value = value.slice(0, 10); // Limit to 8 digits
        }

        if (value.length > 4) {
            value = value.slice(0, 4) + '/' + value.slice(4);
        }

        if (value.length > 2) {
            value = value.slice(0, 2) + '/' + value.slice(2);
        }
        return value;
    }
}